import styled from 'styled-components';
import Select from 'react-select';
import { themedSelectMenuCss } from '../../theme/selectStyles';
import { fontUi } from '../../theme/typography';

export const StyledBar = styled.div`
  ${fontUi};
  display: flex;
  flex-direction: row;
  align-items: center;
  justify-content: flex-start;
  background: ${({ theme }) => theme.card};
  border: 1px solid ${({ theme }) => theme.border};
  border-radius: ${({ theme }) => theme.cardRadius};
  margin-bottom: 10px;
  padding: 8px 14px;
  ${({ $embedded, theme }) =>
    $embedded &&
    `
    background: transparent;
    border: 0;
    border-radius: 0;
    margin-bottom: 0;
    border-bottom: 1px solid ${theme.borderSubtle};
  `}
`;

export const StyledLabel = styled.span`
  ${fontUi};
  font-size: 12px;
  font-weight: 600;
  margin-right: 12px;
  color: ${({ theme }) => theme.textMuted};
`;

export const StyledSelect = styled(Select)`
  width: 220px;
  ${fontUi};

  .react-select__control {
    min-height: 34px;
    height: 34px;
    border: 1px solid ${({ theme }) => theme.border};
    background: ${({ theme }) => theme.inset};
    box-shadow: none;
    font-size: 12px;
    font-weight: 600;
  }

  .react-select__control:hover {
    border-color: ${({ theme }) => theme.border};
  }

  .react-select__control--is-focused {
    border-color: ${({ theme }) => theme.border};
    box-shadow: none;
  }

  .react-select__value-container {
    height: 34px;
    padding: 0 8px;
  }

  .react-select__single-value {
    color: ${({ theme }) => theme.text};
  }

  .react-select__indicators {
    height: 34px;
  }

  .react-select__indicator-separator {
    display: none;
  }

  .react-select__dropdown-indicator {
    color: ${({ theme }) => theme.textFaint};
  }

  ${themedSelectMenuCss}
`;
